import React from "react";
import styled from "styled-components";
import { connect } from "formik";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { FormikInputTypeAhead, FormikInputText, FormikInputPercent } from "@loanbossinc/component-library";

const StyledGridContainer = styled(Grid)`
  && {
    margin-top: 26px;
  }
`;

const StyledFormikInputText = styled(FormikInputText)`
  &&&& {
    width: 100%;
  }
`;

const StyledFormikInputPercent = styled(FormikInputPercent)`
  &&&& {
    width: 100%;
  }
`;

const StyledFormikInputTypeAhead = styled(FormikInputTypeAhead)`
  border-bottom: 1px solid #2196f3;
  width: 100%;
`;

const StyledHeaderContainer = styled(Grid)`
  && {
    margin-top: 23px;
  }
`;

const StyledHeader = styled.span`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    color: #000000;
  }
`;

const GuarantyTypeSection = ({ formik }) => {
  const { values } = formik;

  const guarantyTypes = values?.ancillary?.guarantyTypes ?? [];
  const recourseTypes = values?.ancillary?.recourseTypes ?? [];

  return (
    <Grid container>
      <StyledHeaderContainer item xs={12}>
        <StyledHeader>Guaranty Type</StyledHeader>
      </StyledHeaderContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="loanTypeId"
          name="recourse.guaranteeTypeId"
          label="Guaranty Type"
          options={guarantyTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="loanTypeId"
          name="recourse.recourseTypeId"
          label="Recourse Type"
          options={recourseTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer container item xs={12}>
        <StyledFormikInputPercent name={"recourse.amount"} label={"Amount (%)"} variant={"filled"} />
      </StyledGridContainer>

      <StyledGridContainer container item xs={12}>
        <StyledFormikInputText name={"recourse.misc"} label={"Miscellaneous"} variant={"filled"} multiline />
      </StyledGridContainer>
    </Grid>
  );
};

export default compose(connect)(GuarantyTypeSection);
